export default __webpack_public_path__ + "static/media/pencil_2.44fd0355.svg";